/* Geteilter Merker: gibt es irgendwo in der App gerade ungespeicherte
 * Änderungen? Für die Warnung beim Verlassen der Seite (App.vue,
 * `beforeunload`) — siehe TODO.md „Speichern-Knopf statt stillem
 * Speichern".
 *
 * Mehrere Stellen können gleichzeitig etwas Ungespeichertes haben
 * (Spieler-Panel, Rollenänderung in der Nutzerverwaltung) — deshalb ein Satz
 * von Schlüsseln statt eines einzelnen Flags: Erst wenn keine Stelle mehr
 * etwas offen hat, ist wirklich alles gespeichert.
 */

import { ref, computed } from 'vue';

const dirtyKeys = ref(new Set());

export function useUnsavedChanges() {
  /** @param {string} key  eindeutiger Name der Stelle, z. B. "player-panel" */
  function setDirty(key, isDirty) {
    if (dirtyKeys.value.has(key) === !!isDirty) return;
    const next = new Set(dirtyKeys.value);
    isDirty ? next.add(key) : next.delete(key);
    dirtyKeys.value = next;
  }

  const hasUnsaved = computed(() => dirtyKeys.value.size > 0);

  return { setDirty, hasUnsaved };
}
